import _ from "lodash"

// Formik validation
import * as Yup from "yup"
import {  regexp, } from "common/global/functions.js"

const getSelectObject = (selectOptions, value) =>
  selectOptions.filter(option => option.value == value)[0]

export const shareSchema = ({ 
  signup_id, 
  firstname,
  lastname,
  email,
}) => {
  return {
    enableReinitialize: true,
    initialValues: {
      signup_id, 
      firstname,
      lastname,
      email,
    },
    validationSchema: Yup.object({
      signup_id: Yup.number()
        .required("Invalid Id"),
      firstname: Yup.string()
        .nullable()
        .max(50, "Maximum of 50 characters")
        .required("First Name is required"),
      lastname: Yup.string()
        .nullable()
        .max(50, "Maximum of 50 characters")
        .required("Last Name is required"),
      email: Yup.string()
        .nullable()
        .email("Please Enter a valid Email Address")
        .required("Email Address is required"),
    }),
  }
}

export const smsSchema = ({
  signup_id, 
  firstname,
  lastname,
  cellphone,
}) => {
  return {
    enableReinitialize: true,
    initialValues: {
      signup_id,
      firstname,
      lastname,
        cellphone,
    },
    validationSchema: Yup.object({
      signup_id: Yup.number()
        .required("Invalid Id"),
        firstname: Yup.string()
          .nullable()
          .max(50, "Maximum of 50 characters")
          .required("First Name is required"),
        lastname: Yup.string()
          .nullable()
          .max(50, "Maximum of 50 characters")
          .required("Last Name is required"),
      cellphone: Yup.string()
        .nullable()
        //.max(11, "Maximum of 11 characters")
        .required("Cell Phone is required")
        .matches(regexp.phone, "Invalid phone format."),
    }),
  }
}

export const connectSchema = ({
  signup_id,
  co_signer,
}) => {
  return {
    enableReinitialize: true,
    initialValues: {
      signup_id,
      co_signer,
    },
    validationSchema: Yup.object({
      signup_id: Yup.number()
        .required("Invalid Id"),
      co_signer: Yup.object().shape({
          value: Yup.string()
            .required("Please select an applicant"),
          label: Yup.string(),
      }),
    }),
  }
}